module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "navbar",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('div', {
    staticClass: "navbar-right"
  }, [_c('div', {
    attrs: {
      "id": "avatarUpload"
    }
  }, [_c('img', {
    staticClass: "login-img",
    attrs: {
      "src": _vm.loginImg
    }
  })]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "login-img-box",
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link login-name",
    attrs: {
      "title": _vm.userName
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.phone === '13501189583' || _vm.phone === '15018955912' || _vm.phone === 'Mok' || _vm.phone === '65263913' ? false : true) ? _c('el-dropdown-item', {
    attrs: {
      "command": "message"
    }
  }, [(_vm.unreadMsg) ? _c('div', {
    staticClass: "redSpot"
  }, [_c('i')]) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "svg-icon svg-head-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-tongzhi"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('notify.Notifications')))])]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "user"
    }
  }, [_c('svg', {
    staticClass: "svg-icon svg-head-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-yonghu1"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('user.title')))])]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "logout"
    }
  }, [_c('svg', {
    staticClass: "svg-icon svg-head-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-tuichu"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.Logout')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line-class"
  }), _vm._v(" "), _c('div', {
    staticClass: "lang-box"
  }, [_c('ul', {
    staticClass: "lang-ul"
  }, [_c('li', {
    class: ['lang-item', {
      'active': _vm.isEn
    }],
    on: {
      "click": function($event) {
        _vm.changeLocale('en')
      }
    }
  }, [_vm._v("En")]), _vm._v(" "), _c('li', {
    class: ['lang-item', {
      'active': _vm.isZh_tw
    }],
    on: {
      "click": function($event) {
        _vm.changeLocale('zh_tw')
      }
    }
  }, [_vm._v("繁")]), _vm._v(" "), _c('li', {
    class: ['lang-item', {
      'active': _vm.isZh_cn
    }],
    on: {
      "click": function($event) {
        _vm.changeLocale('zh_cn')
      }
    }
  }, [_vm._v("简")])])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "isShowUser notify-dialog",
    attrs: {
      "title": _vm.$t('user.title'),
      "width": "360px",
      "lock-scroll": false,
      "close-on-click-modal": false,
      "center": "",
      "show-close": false,
      "visible": _vm.dialogUserVisible,
      "custom-class": "custom-dialogUser",
      "modal-append-to-body": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogUserVisible = $event
      }
    }
  }, [_c('el-upload', {
    attrs: {
      "id": "avatarUpload1",
      "action": "/api/share/picture/upload",
      "on-success": _vm.uploadSuccess,
      "before-upload": _vm.beforeImgUpload,
      "show-file-list": false,
      "name": "upfile",
      "list-type": "picture",
      "headers": _vm.headers
    }
  }, [_c('img', {
    staticClass: "login-img",
    attrs: {
      "src": _vm.loginImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user_input"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInputVisible),
      expression: "isInputVisible"
    }],
    staticClass: "user_text",
    attrs: {
      "title": _vm.userName
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isInputVisible),
      expression: "!isInputVisible"
    }],
    attrs: {
      "clearable": "",
      "type": "text",
      "placeholder": _vm.$t('user.placeholder'),
      "autoComplete": "off",
      "id": "userName"
    },
    on: {
      "clear": _vm.clearInput,
      "input": function($event) {
        _vm.setlenght(_vm.userName, 12)
      },
      "blur": _vm.removeStyle
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.removeStyle($event)
      }
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "userName"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tip",
    attrs: {
      "title": _vm.$t('user.tips')
    }
  }, [_vm._v(_vm._s(_vm.$t('user.tips')))]), _vm._v(" "), _c('div', {
    staticClass: "psw_box"
  }, [_c('span', {
    staticClass: "psw-change",
    on: {
      "click": _vm.showPsw
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.PasswordChange')))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "footer-ok",
    on: {
      "click": function($event) {
        _vm.submitUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user.OK')))]), _vm._v(" "), _c('el-button', {
    staticClass: "footer-cancel footer-cancen-btn",
    on: {
      "click": function($event) {
        _vm.closeUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user.Cancel')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "modifyPwd",
    attrs: {
      "title": _vm.$t('modifyPwd.PasswordChange'),
      "lock-scroll": false,
      "close-on-click-modal": false,
      "show-close": false,
      "visible": _vm.dialogFormVisible,
      "custom-class": "custom-dialog",
      "modal-append-to-body": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "pwdForm",
    attrs: {
      "model": _vm.pwdForm,
      "rules": _vm.modifyPwdRule,
      "inline": true,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "id": "oldPwdItem",
      "prop": "oldPwd"
    }
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('label', {
    attrs: {
      "for": "oldPwdInput",
      "id": "oldPwd"
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.OriginalPassword')))]), _vm._v(" "), _c('el-input', {
    staticClass: "floatLabel",
    attrs: {
      "type": "password",
      "autoComplete": "off",
      "id": "oldPwdInput",
      "maxlength": 50,
      "name": "Input1",
      "readonly": ""
    },
    on: {
      "focus": function($event) {
        _vm.addActive('oldPwd')
      },
      "blur": function($event) {
        _vm.delActive('oldPwd')
      }
    },
    model: {
      value: (_vm.pwdForm.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "oldPwd", $$v)
      },
      expression: "pwdForm.oldPwd"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "id": "newPwdItem",
      "prop": "newPwd"
    }
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('label', {
    attrs: {
      "for": "newPwdInput",
      "id": "newPwd"
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.NewPassword')) + "\n                        "), _c('span', {
    staticClass: "hintInfo",
    attrs: {
      "id": "newPwdSpan"
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.PleaseInputMoreThan6DigitsPassword')))])]), _vm._v(" "), _c('el-input', {
    staticClass: "floatLabel",
    attrs: {
      "type": "password",
      "autoComplete": "off",
      "id": "newPwdInput",
      "maxlength": 50,
      "name": "Input2",
      "readonly": ""
    },
    on: {
      "focus": function($event) {
        _vm.addActive('newPwd', 'newPwdSpan')
      },
      "blur": function($event) {
        _vm.delActive('newPwd', 'newPwdSpan')
      }
    },
    model: {
      value: (_vm.pwdForm.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "newPwd", $$v)
      },
      expression: "pwdForm.newPwd"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "id": "confirmPwdItem",
      "prop": "confirmPwd"
    }
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('label', {
    attrs: {
      "for": "confirmPwdInput",
      "id": "confirmPwd"
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.Confirm')) + "\n                        "), _c('span', {
    staticClass: "hintInfo",
    attrs: {
      "id": "comfirmPwdSpan"
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.PleaseBeTheSameAsOriginalPassword')))])]), _vm._v(" "), _c('el-input', {
    staticClass: "floatLabel",
    attrs: {
      "type": "password",
      "autoComplete": "off",
      "id": "confirmPwdInput",
      "maxlength": 50,
      "name": "Input3",
      "readonly": ""
    },
    on: {
      "focus": function($event) {
        _vm.addActive('confirmPwd', 'comfirmPwdSpan')
      },
      "blur": function($event) {
        _vm.delActive('confirmPwd', 'comfirmPwdSpan')
      }
    },
    model: {
      value: (_vm.pwdForm.confirmPwd),
      callback: function($$v) {
        _vm.$set(_vm.pwdForm, "confirmPwd", $$v)
      },
      expression: "pwdForm.confirmPwd"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "footer-ok",
    on: {
      "click": function($event) {
        _vm.submitForm('pwdForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('modifyPwd.OK')))]), _vm._v(" "), _c('el-button', {
    staticClass: "footer-cancel footer-cancen-btn",
    on: {
      "click": function($event) {
        _vm.closeModifyPwd('pwdForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.Cancel')))])], 1)], 1), _vm._v(" "), (_vm.phone === '13501189583' || _vm.phone === '15018955912' || _vm.phone === 'Mok' || _vm.phone === '65263913' ? false : true) ? _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.notifyLoading),
      expression: "notifyLoading"
    }],
    staticClass: "notify-dialog",
    attrs: {
      "title": _vm.$t('notify.NotificationList'),
      "lock-scroll": false,
      "close-on-click-modal": false,
      "show-close": true,
      "visible": _vm.dialogMessage,
      "custom-class": "message-dialog",
      "modal-append-to-body": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogMessage = $event
      }
    }
  }, [_c('ul', {
    staticClass: "notify-ul"
  }, _vm._l((_vm.notifyData), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "notify-item",
      on: {
        "click": function($event) {
          _vm.showMsgDetail(item, index)
        }
      }
    }, [_c('div', [(item.readState == 0) ? _c('i') : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "nofity-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "nofity-time"
    }, [_vm._v(_vm._s(_vm._f("parseTime")(item.addedDate, '{y}-{m}-{d}')))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "18px"
      },
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  })), _vm._v(" "), _c('el-dialog', {
    staticClass: "notify-dialog notify-detail-dialog",
    attrs: {
      "title": _vm.$t('notify.NofiticationDetails'),
      "lock-scroll": false,
      "close-on-click-modal": false,
      "show-close": false,
      "visible": _vm.dialogMsgDetail,
      "custom-class": "message-dialog",
      "modal-append-to-body": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogMsgDetail = $event
      }
    }
  }, [_c('div', {
    staticClass: "notify-detail"
  }, [_c('div', [_c('span', [_vm._v(" " + _vm._s(_vm.msgDetailData.title) + " ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm._f("parseTime")(_vm.msgDetailData.addedDate, '{y}-{m}-{d}')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "concentBox",
    domProps: {
      "innerHTML": _vm._s(_vm.nitifyContent)
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "footer_ok",
    on: {
      "click": _vm.closeMsg
    }
  }, [_vm._v(_vm._s(_vm.$t('button.OK')))])], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3ecfcee3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ecfcee3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Navbar.vue
// module id = 9V4I
// module chunks = 101